function Assembly(assembly) {
  this.id = assembly.id;
  this.calculationUid = assembly.calculation_uid;
  this.assemblyHours = assembly.assembly_hours;
  this.headCount = assembly.head_count;
  this.itemList = [];
}

export default Assembly;
